<template>
<div :class="['list-group-item--content-wrapper', 'draggable-item', 'draggable-item-context-card']">
    <div class="main-content" :class="[productionOrderCardClicableClass]">
        <div class="content order-reference-content"  @click="$emit('toggleMenu', orderReference.id)">
            <div class="order-reference-content-title" :class="orderReferenceContentTitleClasses">
                <div class="order-reference-content-row">
                    <div class="client-name">
                        <div class="client-name--icon icon"><i class="mdi mdi-account-tie"></i></div>
                        <div class="client-name--name text-collapser">{{ orderReferenceFormattedData.client_name }}</div>
                    </div>
                    <div class="batch">
                        <div class="batch--icon icon"><i class="mdi mdi-clipboard-text"></i></div>
                        <div class="batch--name">{{ orderReferenceFormattedData.batch }}</div>
                    </div>
                </div>
            </div>
            <div class="order-reference-content-body">
                <div class="order-reference-content-row order-reference-content-secondary-info">
                    <div class="brand">
                        <div class="brand--icon icon"><i class="mdi mdi-truck"></i></div>
                        <div class="brand--name text-collapser">{{ orderReferenceFormattedData.shipping_address }}</div>
                    </div>
                    <div class="cargo-date">
                        <div class="cargo-date--icon icon"><i class="mdi mdi-calendar"></i></div>
                        <div class="cargo-date--date">{{orderReferenceFormattedData.cargo_date}}</div>
                    </div>
                </div>
                <div class="order-reference-content-row">
                    <div class="reference">
                        <div class="reference--icon icon"><i class="mdi mdi-clipboard-text"></i></div>
                        <div class="reference--name text-collapser">{{orderReferenceFormattedData.reference}}</div>
                    </div>
                </div>
                <div class="order-reference-content-row order-reference-content-secondary-info row">
                    <div class="amount col" :class="amountClasses">
                        <div class="amount--icon icon"><i class="mdi mdi-package-variant-closed"></i></div>
                        <div class="amount--number">{{orderReferenceFormattedData.produced}} / {{orderReferenceFormattedData.amount}}</div>
                        <div class="amount--unit">{{orderReferenceFormattedData.unit}}</div>
                    </div>
                    <div class="gross-weight col">
                        <div class="gross-weight--icon icon"><i class="mdi mdi-weight-kilogram"></i></div>
                        <div class="gross-weight--name text-collapser">{{ orderReferenceFormattedData.gross_weight }}</div>
                    </div>
                </div>
                <div class="order-reference-content-row order-reference-content-secondary-info row">
                    <div class="order-reference-descrip col">
                        <div class="order-reference-descrip--icon icon"><i class="mdi mdi-tag"></i></div>
                        <div class="order-reference-descrip--descrip">{{ orderReferenceFormattedData.descrip }}</div>
                    </div>
                    <div class="variety col">
                        <div class="variety--icon icon"><i class="mdi mdi-flower-tulip"></i></div>
                        <div class="variety--name text-collapser">{{ orderReferenceFormattedData.variety }}</div>
                    </div>
                </div>
            </div>
            <div v-if="showDivisionAnnexe" class="division-annexe">
                <div class="division-left-section">
                    <div class="amount--icon icon">
                        <i class="mdi mdi-package-variant-closed"></i>
                    </div>
                    <div class="division-quantity">
                        {{ orderReferenceFormattedData.unit }} totales: <span class="division-annexe-numbers">{{ orderReferenceFormattedData.summed_produced_quantity_of_divisions }} / {{ orderReferenceFormattedData.summed_real_quantity_of_divisions }}</span>
                    </div>
                </div>
                <div class="division-right-section">
                    <div class="division-number--icon icon">
                        <i class="mdi mdi-division-box"></i>
                    </div>
                    <div class="division-quantity--number">
                        <span class="division-annexe-numbers">
                            {{ orderReferenceFormattedData.division_amount }}
                        </span> 
                        divisiones
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
    name: "ProductionOrderCardContent",
    props:{
        orderReference: {
            type: Object,
            default: {}
        },
        canOpenMenu: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return{
            producedQuantity: 0,
        }
    },
    computed:{
        ...mapGetters('production_control',['kanbanOrderReferencesInQueueByProductionLineId', 'kanbanPendingOrderReferences', 'queueEditActive']),
        ...mapGetters(['userPermissions','userHasPermission']),
        formatOrderReferenceDescrip(){
            let descrip = this.orderReference.descrip ? this.orderReference.descrip : 'Sin descripción';
            return descrip;
        },
        orderReferenceFormattedData(){
            const dateTimeString = this.orderReference.cargo_date ? this.orderReference.cargo_date : 'Fecha de carga N/D';
            const dateObj = new Date(dateTimeString);
            const isValidDate = !isNaN(dateObj.getTime());
            const formattedDate = isValidDate ? dateObj.toLocaleDateString() : 'Fecha de carga no válida';
            
            return {
                descrip:                                this.formatOrderReferenceDescrip || 'Descripción de orden N/D',
                id:                                     this.orderReference.id,
                cargo_date:                             formattedDate,
                amount:                                 this.orderReference.real_quantity || '0',
                unit:                                   'Cajas',
                produced:                               this.orderReference.produced_quantity || '0',
                batch:                                  this.orderReference.batch? this.orderReference.batch: 'Lote N/D',
                reference:                              this.orderReference.reference?.descrip || 'Descripción de artículo N/D',
                shipping_address:                       this.orderReference?.order?.client?.name || 'Dirección de envío N/D',
                division_amount:                        this.orderReference.divisions ? this.orderReference.divisions.length : 0,
                summed_produced_quantity_of_divisions:  this.summedProducedQuantityOfDivisions,
                summed_real_quantity_of_divisions:      this.summedRealQuantityOfDivisions,
                ext_pk:                                 this.orderReference.ext_pk || 'Clave externa N/D',
                variety:                                this.orderReference.variety || 'Variedad N/D',
                client_name:                            this.orderReference?.order?.client?.business_name || 'Cliente N/D',
                gross_weight:                           ( this.orderReference.reference.gross_weight ? this.textToDecimal(this.orderReference.reference.gross_weight) : '0,000' ) + ' KG/Caja',
            }
        },
        isPending(){
            return this.orderReference.order_state_id == 1;
        },
        isProducing(){
            return this.orderReference.order_state_id == 2;
        },
        showDivisionAnnexe(){
            return (this.orderReference.divisions && this.orderReference.divisions.filter(copy => copy.id !== this.orderReference.id).length > 0);
        },
        summedProducedQuantityOfDivisions(){
            return this.orderReference.divisions.reduce((acc, copy) => acc + copy.produced_quantity, 0) || 0;
        },
        summedRealQuantityOfDivisions(){
            return this.orderReference.divisions.reduce((acc, copy) => acc + copy.real_quantity, 0) || 0;
        },
        hasDangerQuantity(){
            return this.orderReferenceFormattedData.produced > this.orderReferenceFormattedData.amount;
        },
        amountClasses(){
            let classes = [];
            if(this.hasDangerQuantity){
                classes.push('danger-quantity');
                if(this.isProducing){
                    classes.push('danger-quantity-blink');
                }
            }
            return classes;
        },
        productionOrderCardClicableClass() {
            let classes = [];
            if (this.isPending) return;
            if (this.canOpenMenu) {
                classes.push('clicable');
            } else {
                classes.push('not-clicable');
            }
            return classes;
        },
        orderReferenceContentTitleClasses(){
            let classes = [];
            if (this.orderReference.order.is_stock_order) {
                classes.push('stock-order');
            }
            return classes;
        },
    },
    methods:{
        textToDecimal(value){
            return Number(value).toLocaleString('es-ES', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
        },
    },
}
</script>